import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'
import {
  addHtmlElementClass,
  EMPTY_ADDRESS,
  isDefined,
  isValidUserAddress,
  parseDateIsoFormat,
  parseShipmentAddress,
  removeHtmlElementClass
} from "../../utils/utils";
import { refreshJwtToken } from "../../utils/mercurio.utils";
import AddressForm from "./AddressForm";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ErrorModal from "./ErrorModal";
import IconTooltip from "./IconTooltip";
import EbayLinkExplanatorModal from "./EbayLinkExplanatorModal";
import EbayLinkActivator from "./EbayLinkActivator";
import IndexSaleItems from "./IndexSaleItems";
import EbayLinkDeletorModal from "./EbayLinkDeletorModal";



const MerchantLocationKeySelector = ({
  userAddresses,
  countries,
  merchantLocationKeyFormSubmitted,
  setMerchantLocationKeyFormSubmitted,
  newAddress,
  shipmentAddress,
  setShipmentAddress,
  updateShipmentAddressParams
}) => {

  const [openOldAddressesAccordion, setOpenOldAddressesAccordion] = useState(isDefined(shipmentAddress?.id))

  return <React.Fragment>
    {
      userAddresses?.length === 0 ?
        <AddressForm
          shipmentAddress={shipmentAddress}
          updateShipmentAddressParams={updateShipmentAddressParams}
          countries={countries}
          canUpdate={true}
          addressType={'user'}
          formSubmitted={merchantLocationKeyFormSubmitted}
          hideEmail={true}
        />
        :
        <React.Fragment>
          <Accordion expanded={openOldAddressesAccordion}
            className="mt-3"
            key={'set_old_shipment_address'}
            onChange={(e) => {
              setOpenOldAddressesAccordion(!openOldAddressesAccordion);
              setShipmentAddress(null);
              setMerchantLocationKeyFormSubmitted(false);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="accordion1-content"
              id="accordion1-header"
              className={"bg-aig-gradient br-10px-imp ebay-merchant-location-key-accordion"}
            >
              <h4 className="text-space my-0">
                {I18n.t('js.indexSaleItems.ebayLink.merchantLocationKeyModal.setOldAddress')}
              </h4>
            </AccordionSummary>
            <AccordionDetails>
              <div className="d-block">
                {

                  userAddresses.map(address => {
                    return <div className="row px-5 pt-3 w-100 w-100 text-left custom-control custom-radio"
                      id={'address_' + address.id} key={'address_' + address.id}>
                      <input
                        type="radio"
                        id={'input_address_' + address.id}
                        name={'input_address_' + address.id}
                        value={address.id}
                        checked={address.id === shipmentAddress?.id}
                        className="aiG-radio custom-control-input"
                        onChange={() => setShipmentAddress(address)}
                      />
                      <label
                        className="aiG-label-radio custom-control-label font-weight--normal"
                        id={"label_address_" + address.id}
                        htmlFor={'input_address_' + address.id}
                      > {parseShipmentAddress(address)}
                      </label>
                    </div>
                  })
                }
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={!openOldAddressesAccordion}
            className="mt-3"
            key={'create_new_shipment_address'}
            onChange={(e) => {
              setOpenOldAddressesAccordion(!openOldAddressesAccordion);
              setShipmentAddress(newAddress);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="accordion2-content"
              id="accordion2-header"
              className={"bg-aig-gradient br-10px-imp ebay-merchant-location-key-accordion"}
            >
              <h4 className="text-space my-0">
                {I18n.t('js.indexSaleItems.ebayLink.merchantLocationKeyModal.createNewAddress')}
              </h4>
            </AccordionSummary>
            <AccordionDetails>
              {
                shipmentAddress &&
                <AddressForm
                  shipmentAddress={shipmentAddress}
                  updateShipmentAddressParams={updateShipmentAddressParams}
                  countries={countries}
                  canUpdate={true}
                  addressType={'user'}
                  formSubmitted={merchantLocationKeyFormSubmitted}
                  hideEmail={true}
                />
              }
            </AccordionDetails>
          </Accordion>
        </React.Fragment>
    }
  </React.Fragment>
}



const SellerStatusExplanation = ({ ebay }) => {
  return <React.Fragment>
    {
      [1, 2, 3, 4, 5].map(index => {
        return <p key={`seller_status_p_${index}`}>
          {I18n.t(`js.indexSaleItems.ebayLink.sellerStatusModal.text_${index}`).replaceAll(':sale_channel', ebay.meta_name)}
          {index === 3 &&
            <b>
              {I18n.t(`js.indexSaleItems.ebayLink.sellerStatusModal.text_${index}_1`).replaceAll(':sale_channel', ebay.meta_name)}
            </b>
          }
        </p>
      })
    }
  </React.Fragment>
}



const EbayLinkSummary = ({
  originalJwtToken,
  user,
  eBay,
  countries,
  user_addresses,
  accessTokensEndpoint,
  checkUserEbayLinkEndpoint,
  ebayUserLoginEndpoint,
  defaultEbayMarketplace,
  favoriteMarketplaceEndpoint,
  merchantLocationKeyEndpoint,
  mercurioBaseUrl,
  indexSaleItemsProps
}) => {

  const ebay = JSON.parse(eBay)
  const userAddresses = JSON.parse(user_addresses)
  const [ebayLink, setEbayLink] = useState(null);
  const [marketplaceUrl, setMarketplaceUrl] = useState(null);
  const [ebayLinkActivationStep, setEbayLinkActivationStep] = useState(null);
  const [ebayLinkStatus, setEbayLinkStatus] = useState(null);
  const [initCompleted, setInitCompleted] = useState(false);
  const [jwtToken, setJwtToken] = useState(originalJwtToken);
  const [showEbayLinkDeletorModal, setShowEbayLinkDeletorModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [submittingMerchantLocationKey, setSubmittingMerchantLocationKey] = useState(false);
  const [merchantLocationKeyFormSubmitted, setMerchantLocationKeyFormSubmitted] = useState(false);
  const userDefaultAddress = userAddresses?.length > 0 ? userAddresses.filter(address => address.is_default) : null;
  const [shipmentAddress, setShipmentAddress] = useState(userDefaultAddress?.length > 0 ? userDefaultAddress[0] : EMPTY_ADDRESS);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true);
      // Chiedo al server l'ebay link dell'utente
      getEbayLink();
    }
  }, [initCompleted]);


  useEffect(() => {
    let newEbayLinkStatus = null;
    if (isDefined(ebayLink?.id) && isDefined(ebayLink?.favorite_marketplace))
      newEbayLinkStatus = 'just_created';
    if (newEbayLinkStatus === 'just_created' && ebayLink.expired?.toString() !== 'true')
      newEbayLinkStatus = 'active';
    if (newEbayLinkStatus === 'just_created' && ebayLink.expired?.toString() === 'true')
      newEbayLinkStatus = 'expired';
    if (newEbayLinkStatus === 'active' && ebayLink?.seller_registration_completed?.toString() == 'true' && isDefined(ebayLink?.default_merchant_location_key))
      newEbayLinkStatus = 'completed';
    setEbayLinkStatus(newEbayLinkStatus);
    if ([null, 'expired'].includes(newEbayLinkStatus)) {
      removeHtmlElementClass(document, "ebay_activator_link", "d-none");
      addHtmlElementClass(document, "ebay_activator_link", "d-flex");
    } else {
      removeHtmlElementClass(document, "ebay_activator_link", "d-flex");
      addHtmlElementClass(document, "ebay_activator_link", "d-none");
    }

    if (isDefined(newEbayLinkStatus) && ebayLink?.seller_registration_completed?.toString() !== 'true')
      setEbayLinkActivationStep(1);

    if (ebayLink?.favorite_marketplace) {
      const marketplace = ebay.marketplaces.filter(market => market.name === ebayLink.favorite_marketplace);
      setMarketplaceUrl(marketplace?.length > 0 ? marketplace[0].web_site_url : null);
    } else
      setMarketplaceUrl(null);
  }, [ebayLink]);


  // Funzione che verifica quale step debba completare l'utente per completare l'attivazione del suo ebay Link
  const checkEbayLinkActivationStep = () => {
    if (!isDefined(ebayLink?.id) || !isDefined(ebayLink?.favorite_marketplace))
      return [0, I18n.t('js.indexSaleItems.alertTooltip.ebay.missingSaleChannelLink').replaceAll(':sale_channel', ebay.meta_name)];
    else if (ebayLink?.seller_registration_completed?.toString() !== 'true')
      return [1, I18n.t('js.indexSaleItems.alertTooltip.ebay.missingSaleChannelLinkSellerPrivileges').replaceAll(':sale_channel', ebay.meta_name)];
    else if (!isDefined(ebayLink?.default_merchant_location_key))
      return [2, I18n.t('js.indexSaleItems.alertTooltip.ebay.incompleteSaleChannelLink').replaceAll(':sale_channel', ebay.meta_name)];
    else if (ebayLink.expired?.toString() === 'true')
      return [3, I18n.t('js.indexSaleItems.alertTooltip.ebay.expiredSaleChannelLink').replaceAll(':sale_channel', ebay.meta_name)];
    return [null, ''];
  }


  // Funzione che permette di ottenere l'ebay link dell'utente con ebay
  const getEbayLink = (firstRun = true, token = null) => {
    fetch(checkUserEbayLinkEndpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token || jwtToken
      },
      body: JSON.stringify({
        user_email: user.email
      }),
    })
      .then((res) => {
        if (!res.ok) {
          if (res.redirected && res.status === 404 && res.url.includes("/users/sign_in")) {
            if (firstRun)
              refreshJwtToken(getEbayLink);
          } else
            throw Error("An error occour during getting user access_token from mercurio");
        }
        else
          return res.json()
      })
      .then((data) => {
        setEbayLink(data);
      })
      .catch((error) => {
        console.log(error);
        setShowErrorModal(true);
      });
  }


  // Funzione che si occupa della chiusura della modale che spiega all'utente i vari passi necessari per attivare
  // il suo ebay link
  const handleCloseEbayLinkActivationStepsModal = () => {
    setMerchantLocationKeyFormSubmitted(false);
    setEbayLinkActivationStep(null);
  }


  // Funzione che permette di aggiornare i vari campi della nuova merchant location key
  // che l'utente sta creando sull'interfaccia grafica
  const updateShipmentAddressParams = (keys, values) => {
    const newAddress = { ...shipmentAddress }
    for (let i = 0; i < keys.length; i++)
      newAddress[keys[i]] = values[i]
    setShipmentAddress(newAddress)
  }


  // Funzione che comunica al server la merchant location key impostata dall'utente come suo indirizzo predefinito
  // per la vendita su ebay
  const handleConfirmMerchantLocationKeyForm = (firstRun = false, token = null) => {
    const submitMerchantLocationKey = () => {
      setSubmittingMerchantLocationKey(true);

      fetch(merchantLocationKeyEndpoint + ".json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": token || jwtToken
        },
        body: JSON.stringify({
          user_email: user.email,
          shipment_address: shipmentAddress,
        }),
      })
        .then((response) => {
          setSubmittingMerchantLocationKey(false);
          setMerchantLocationKeyFormSubmitted(false);
          if (!response.ok) {
            if (response.redirected && response.status === 404 && response.url.includes("/users/sign_in")) {
              if (firstRun)
                refreshJwtToken(handleConfirmMerchantLocationKeyForm)
            } else
              throw Error("An error occour during getting user access_token from mercurio");
          }
          else
            return response.json();
        })
        .then((data) => {
          setEbayLink({ ...ebayLink, default_merchant_location_key: data.default_merchant_location_key })
          handleCloseEbayLinkActivationStepsModal();
        })
        .catch((error) => {
          console.error("ERROR:", error);
          handleCloseEbayLinkActivationStepsModal();
          setShowErrorModal(true);
        });
    }

    if (isDefined(shipmentAddress)) {
      setMerchantLocationKeyFormSubmitted(true);

      if (isDefined(shipmentAddress.id))
        submitMerchantLocationKey();
      else if (isValidUserAddress(shipmentAddress, null, false, true))
        submitMerchantLocationKey();
    }
  }


  // Funzione che cancella l'ebay link dell'utente
  const handleDeleteUserEbayLink = () => {
    fetch(`${accessTokensEndpoint}/${ebayLink.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwtToken
      }
    })
      .then((response) => {
        setShowEbayLinkDeletorModal(false);
      })
      .then((data) => {
        setEbayLink({ ...ebayLink, id: null, created_at: null, favorite_marketplace: null, default_merchant_location_key: null });
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }




  return <React.Fragment>
    {/*SEZIONE DEDICATA AL RIEPILOGO DELL'EBAY LINK*/}
    <div
      className="row pt-0 py-0 px-0 mb-4 m-0 shadow border-right-aiG-light-gray-imp border-left-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-radius-8px">

      <div
        className="col-12 col-sm-3 col-xxl-1 px-2 py-sm-0 d-flex justify-content-center align-items-center border-right-sm-aiG-light-gray-imp">
        <div
          className={`bg-${[null, 'expired'].includes(ebayLinkStatus) ? 'gray' : 'aig-gradient'} br-50perc p-2px sale_item_icon_container--very-small d-flex flex-directions-column my-2`}>
          <div
            className="position--relative bg-white br-50perc d-flex justify-content-center flex-fill align-items-center p-2">
            <img src={ebay.thumb_logo_url} width="40px"
              className={[null, 'expired'].includes(ebayLinkStatus) ? 'grayscale' : ''} />
          </div>
        </div>
      </div>

      <div className="col-12 col-sm-9 col-xxl-4 border-top-aig-light-gray-imp border-top-sm-none">
        <div className="row h-100">
          <div
            className="col-4 pl-1 pr-0 d-flex justify-content-start align-items-center border-right-aiG-light-gray-imp">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="default_small_label mr-2">
                  {I18n.t('js.indexSaleItems.ebayLink.ebayLink').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
                </span>
              </p>
              <p
                className={`text-truncate mb-1 font-size-15px-imp color-${[null, 'expired'].includes(ebayLinkStatus) ? 'red' : 'green'}`}>
                {I18n.t(`js.indexSaleItems.ebayLink.${ebayLinkStatus === 'expired' ? 'expired' : (isDefined(ebayLinkStatus) ? 'active' : 'inactive')}`)}
              </p>
            </div>
          </div>

          <div
            className="col-4 pl-1 pr-0 d-flex justify-content-start align-items-center border-right-aiG-light-gray-imp">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="default_small_label mr-2">
                  {I18n.t('js.indexSaleItems.ebayLink.registeredOn').toUpperCase()}
                </span>
              </p>
              <p className="text-truncate mb-1 font-size-15px-imp">
                {ebayLink?.created_at ? parseDateIsoFormat(new Date(ebayLink.created_at), '%d/%m/%Y') : '---'}
              </p>
            </div>
          </div>

          <div
            className="col-4 pl-1 pr-0 d-flex justify-content-start align-items-center border-right-xxl-aiG-light-gray-imp">
            <div className="d-block pl-2">
              <p className="mt-1">
                <span className="default_small_label mr-2">
                  {I18n.t('js.indexSaleItems.ebayLink.authorizationSite').replaceAll(":sale_channel", ebay.meta_name).toUpperCase()}
                </span>
              </p>
              <div className="text-truncate mb-1 font-size-15px-imp">
                {
                  ebayLink?.favorite_marketplace ?
                    (
                      marketplaceUrl ?
                        <a href={`https://${marketplaceUrl}`} target="_blank">
                          {marketplaceUrl}
                        </a>
                        :
                        <span>{ebayLink.favorite_marketplace}</span>
                    )
                    :
                    <p className="text-truncate mb-1">---</p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="col-12 col-sm-6 col-md-4 col-xxl-2 pl-1 pr-0 d-flex justify-content-start align-items-center border-right-sm-aiG-light-gray-imp border-top-aig-light-gray-imp border-top-xxl-none">
        <div className="d-block pl-2">
          <p className="mt-1">
            <span className="default_small_label mr-2">
              {I18n.t('js.indexSaleItems.ebayLink.sellerStatus').toUpperCase()}
            </span>
          </p>
          <p className={`text-truncate mb-1 font-size-15px-imp ${ebayLink?.id ? (ebayLink?.seller_registration_completed?.toString() === 'true' ? 'color-green' : 'color-red') : ''}`}>
            {ebayLink?.id ? I18n.t(`js.indexSaleItems.ebayLink.${ebayLink?.seller_registration_completed?.toString() === 'true' ? 'enable' : 'disable'}ToSell`) : '---'}
          </p>
        </div>
      </div>

      <div
        className="col-12 col-sm-6 col-md-4 col-xxl-2 pl-1 pr-0 d-flex justify-content-start align-items-center border-top-aig-light-gray-imp border-top-xxl-none">
        <div className="d-block pl-2">
          <p className="mt-1">
            <span className="default_small_label mr-2">
              {I18n.t('js.indexSaleItems.ebayLink.shippingAddress').replaceAll(":sale_channel", ebay.meta_name).toUpperCase()}
            </span>
          </p>
          <p className={`text-truncate mb-1 font-size-15px-imp ${ebayLink?.default_merchant_location_key ? 'color-green' : ''}`}>
            {ebayLink?.default_merchant_location_key ? I18n.t('js.indexSaleItems.ebayLink.confirmed') : '---'}
          </p>
        </div>
      </div>

      <div
        className="col-12 col-md-4 col-xxl-3 h-100 d-flex justify-content-center align-self-center border-top-aig-light-gray-imp border-top-xxl-none">
        <div className="mt-2 mt-xxl-0 d-block text-center">
          {
            [null, 'expired'].includes(ebayLinkStatus) ?
              <EbayLinkActivator
                originalJwtToken={originalJwtToken}
                user={user}
                eBay={eBay}
                ebayLink={ebayLink}
                renderEbayIcon={false}
                ebayUserLoginEndpoint={ebayUserLoginEndpoint}
                defaultEbayMarketplace={defaultEbayMarketplace}
                favoriteMarketplaceEndpoint={favoriteMarketplaceEndpoint}
                mercurioBaseUrl={mercurioBaseUrl}
              />
              :
              <div className="d-flex justify-content-center align-items-center">
                <IconTooltip
                  tooltipContent={I18n.t('js.indexSaleItems.ebayLink.removeLinkTooltip').replaceAll(':sale_channel', ebay.meta_name)}
                  tooltipPosition={'bottom'}
                  customComponentToRender={
                    <React.Fragment>
                      <button type="button"
                        className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                        onClick={() => setShowEbayLinkDeletorModal(true)}
                      >
                        {I18n.t('js.indexSaleItems.ebayLink.removeYour').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
                      </button>
                    </React.Fragment>
                  }
                />
              </div>
          }
          <EbayLinkExplanatorModal
            ebay={ebay}
          />
        </div>
      </div>
    </div>

    {
      indexSaleItemsProps &&
      <IndexSaleItems
        original_sale_items={indexSaleItemsProps.original_sale_items}
        states={indexSaleItemsProps.states}
        sorting_options={indexSaleItemsProps.sorting_options}
        userId={indexSaleItemsProps.userId}
        saleChannels={indexSaleItemsProps.saleChannels}
        saleMethods={indexSaleItemsProps.saleMethods}
        initial_filters={indexSaleItemsProps.initial_filters}
        saleChannelsLinks={{
          [ebay.meta_name]: {
            ...ebayLink,
            state: ebayLinkStatus,
            handlePublishWithUncompleteLink: () => setEbayLinkActivationStep(checkEbayLinkActivationStep()[0]),
            uncompleteLinkAlertMessage: checkEbayLinkActivationStep()[1]
          }
        }}
      />
    }


    {/*Modale che spiega all'utente i vari step necessari per attivare il suo ebay link*/}
    <Modal animation={false} centered size="lg"
      show={isDefined(ebayLinkActivationStep)}
      onHide={handleCloseEbayLinkActivationStepsModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {
            ebayLinkActivationStep === 0 ?
              I18n.t('js.indexSaleItems.ebayLink.activateYour').replaceAll(':sale_channel', ebay.meta_name)
              :
              ebayLinkActivationStep === 1 ?
                I18n.t('js.indexSaleItems.ebayLink.sellerStatusModal.title').replaceAll(':sale_channel', ebay.meta_name)
                :
                ebayLinkActivationStep === 2 ?
                  I18n.t('js.indexSaleItems.ebayLink.merchantLocationKeyModal.title').replaceAll(':sale_channel', ebay.meta_name)
                  :
                  I18n.t('js.indexSaleItems.ebayLink.expirationModal.title').replaceAll(':sale_channel', ebay.meta_name)
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          ebayLinkActivationStep === 0 ?
            <React.Fragment>
              <p>
                {I18n.t(`js.indexSaleItems.ebayLink.activationText.p_1`).replaceAll(':user', user.first_name ? user.first_name : '').replaceAll(':sale_channel', ebay.meta_name)}
              </p>
              <p>
                {I18n.t(`js.indexSaleItems.ebayLink.ebayLinkExplanation.p_1`).replaceAll(':sale_channel', ebay.meta_name)}
              </p>

              <p>
                {I18n.t(`js.indexSaleItems.ebayLink.activationText.p_2`).replaceAll(':sale_channel', ebay.meta_name)}
              </p>
              <p>
                {I18n.t(`js.indexSaleItems.ebayLink.ebayLinkExplanation.p_4`).replaceAll(':sale_channel', ebay.meta_name).replaceAll('|', '')}
              </p>
            </React.Fragment>
            :
            ebayLinkActivationStep === 1 ?
              <SellerStatusExplanation
                ebay={ebay}
              />
              :
              ebayLinkActivationStep === 2 ?
                <React.Fragment>
                  <p className="mb-4">
                    <span>
                      {I18n.t('js.indexSaleItems.ebayLink.merchantLocationKeyModal.text_1').replaceAll(':sale_channel', ebay.meta_name)}
                    </span>
                    {
                      userAddresses?.length > 0 &&
                      <span>
                        {I18n.t('js.indexSaleItems.ebayLink.merchantLocationKeyModal.text_2').replaceAll(':sale_channel', ebay.meta_name)}
                      </span>
                    }
                  </p>
                  <MerchantLocationKeySelector
                    userAddresses={userAddresses}
                    countries={countries}
                    merchantLocationKeyFormSubmitted={merchantLocationKeyFormSubmitted}
                    setMerchantLocationKeyFormSubmitted={setMerchantLocationKeyFormSubmitted}
                    newAddress={EMPTY_ADDRESS}
                    shipmentAddress={shipmentAddress}
                    setShipmentAddress={setShipmentAddress}
                    updateShipmentAddressParams={updateShipmentAddressParams}
                  />
                </React.Fragment>
                :
                <p>
                  {I18n.t('js.indexSaleItems.ebayLink.expirationModal.p_1').replaceAll(':user', user.first_name ? user.first_name : '').replaceAll(':sale_channel', ebay.meta_name)}
                </p>
        }

        <div className="d-flex justify-content-end w-100 mx-0 mt-5">
          <div>
            {
              [0, 3].includes(ebayLinkActivationStep) ?
                <EbayLinkActivator
                  originalJwtToken={originalJwtToken}
                  user={user}
                  eBay={eBay}
                  ebayLink={ebayLink}
                  renderEbayIcon={false}
                  ebayUserLoginEndpoint={ebayUserLoginEndpoint}
                  defaultEbayMarketplace={defaultEbayMarketplace}
                  favoriteMarketplaceEndpoint={favoriteMarketplaceEndpoint}
                  mercurioBaseUrl={mercurioBaseUrl}
                  handleOnClickActiveNowButton={handleCloseEbayLinkActivationStepsModal}
                />
                :
                ebayLinkActivationStep === 1 ?
                  <a
                    target="_blank"
                    href={`https://${marketplaceUrl}/sl/sell`}
                    className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                  >
                    {I18n.t('js.indexSaleItems.ebayLink.sellerStatusModal.button').replaceAll(':sale_channel', ebay.meta_name).toUpperCase()}
                  </a>
                  :
                  (submittingMerchantLocationKey ?
                    <div className="align-items-center text-intense-blue my-1">
                      <span className="mr-2">
                        {I18n.t('js.indexSaleItems.ebayLink.favoriteMarketplace.submittingForm')}
                      </span>
                      <div className="spinner-border size-1-5rem-imp" role="status" />
                    </div>
                    :
                    <button
                      type="button"
                      className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                      onClick={handleConfirmMerchantLocationKeyForm}
                    >
                      {I18n.t('js.common.button.save').toUpperCase()}
                    </button>)
            }
          </div>
        </div>
      </Modal.Body>
    </Modal>


    {/* Popup di alert per la cancellazione dell'ebay link dell'utente */}
    <EbayLinkDeletorModal
      ebay={ebay}
      showEbayLinkDeletorModal={showEbayLinkDeletorModal}
      onSuccess={handleDeleteUserEbayLink}
      onDiscard={() => setShowEbayLinkDeletorModal(false)}
    />

    <ErrorModal
      showErrorModal={showErrorModal}
      setShowErrorModal={setShowErrorModal}
    />
  </React.Fragment>
};

export default EbayLinkSummary;